import React, { Fragment, useEffect, useState } from 'react';

import { WithApp } from 'contexts/appContext';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Assignment, Delete } from '@material-ui/icons';
import {
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { wsGetAll, wsPost, wsUpdate } from 'services/WService';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ButtonDelete from 'hooks/ButtonDelete';

import { onlyMoney } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: '500',
  },
  table: {
    minWidth: 650,
  },
  tr: {
    backgroundColor: 'rgb(151, 47, 176)',
    '& th': {
      color: 'white'
    }
  },
  divTable: {
    marginBottom: '15px',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderImage: 'linear-gradient(to top, white, #972fb0) 1',
    borderRadius: '2px',
    overflow: 'auto',
  },
  headerBorder: {
    borderRight: '1px solid white',
    borderLeft: '1px solid white',
  },
});

function InputField(props) {
  return (
    <TextField
      {...props}
      onKeyPress={onlyMoney}
      style={{ marginTop: 0, marginBottom: '3px' }}
      margin="normal"
      size="small"
      fullWidth
      inputProps={{ ...props.inputProps, style: { textAlign: props.type === 'text' ? 'left' : 'right' } }}
    />
  );
};

export default WithApp(function Goal(props) {
  const { incentive, showNotify, reload } = props;
  const classes = useStyles();

  const [providerGroups, setProviderGroups] = useState([]);
  const [categories, setCategories] = useState([]); // Tiene las recompensas en un nodo

  const [sellerGoals, setSellerGoals] = useState([]);
  const [minSellerIds, setMinSellerIds] = useState([]); // Ids de vendededores minoristas
  const [maySellerIds, setMaySellerIds] = useState([]); // Ids de vendededores mayoristas
  const [sellers, setSellers] = useState([]);
  const [minSeller, setMinSeller] = useState(null);
  const [maySeller, setMaySeller] = useState(null);

  const [dataImport, setDataImport] = useState([]);

  async function addSellerGoals(canalId){
    let seller = null
    if(canalId === 1){
      seller = minSeller;
    }
    if(canalId === 2){
      seller = maySeller;
    }
    
    if(seller === null){
      showNotify('Seleccione un vendedor', 'error');
      return;
    }

    let response = await wsPost(`com/incentive/${incentive.id}/goal/add-seller`, {
      base_seller_id: seller.id,
      base_canal_id: canalId,
    });

    if(response.success){
      showNotify(response.message);
      setData(response.data, undefined);

    }else{
      showNotify(response.message, 'error');
    }
  }

  async function removeSeller(sellerId, canalId){
    let response = await wsPost(`com/incentive/${incentive.id}/goal/remove-seller`, {
      base_seller_id: sellerId,
      base_canal_id: canalId,
    });

    if(response.success){
      showNotify(response.message);
      setData(response.data, undefined);
    }else{
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    loadGoalData();
  }, [incentive]);

  useEffect(() => {
    if(dataImport.length === 0){
      return;
    }

    let updatedGoals = dataImport.data.map(goal => {
      return {
        id: goal.Codigo,
        goal: goal.Meta,
      };
    });

    wsUpdate(`com/incentive/${incentive.id}/goal`, {
      goals: updatedGoals,
    }).then(response => {
      if(response.success){
        showNotify(response.message);
      }else{
        showNotify(response.message, 'error');
      }
      
      setDataImport([]);
      loadGoalData();
    });
  }, [dataImport]);

  async function loadGoalData(){
    let [goalResponse, sellerResponse] = await Promise.all([
      wsGetAll(`com/incentive/${incentive.id}/excel-goal-data`),
      wsGetAll(`base/zone/${incentive.base_zone_id}/sellers`),
    ]);

    setData(goalResponse.data, sellerResponse.data);
  }

  async function setData(goalData, sellerData = undefined){
    setProviderGroups(goalData.providers);
    setCategories(goalData.categories);
    setSellerGoals(goalData.sellers);
    setMinSellerIds(goalData.sellers.filter(seller => seller.minorista === 'Y').map(seller => seller.id));
    setMaySellerIds(goalData.sellers.filter(seller => seller.mayorista === 'Y').map(seller => seller.id));
    
    setMinSeller(null);
    setMaySeller(null);

    if(sellerData !== undefined){
      setSellers(sellerData);
    }
  }

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color="primary" pointer="true">
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Metas</h4>
      </CardHeader>

      <CardBody>
        <GridContainer>
          {/* Minorista */}
          <GridItem xs={4} md={4} lg={4}>
            <h4>
              <b>Minorista</b>
            </h4>
          </GridItem>
          <GridItem xs={12} md={12} lg={12}>
            <ImportExcel
              fileInputId="importar-minorista"
              setDataImport={setDataImport}
              btnColor="success"
              btnLabel="Importar"
              validDuplicate="Codigo"
              downTemplate={{
                fileNameDown: 'metasMinorista',
                fields: [
                  'Codigo',
                  'SlpCode',
                  'Vendedor',
                  'Proveedor',
                  'Categoria',
                  'Canal',
                  'TipoMeta',
                  'Meta',
                ],
                data: function(){
                  return sellerGoals.filter(seller => seller.minorista === 'Y').reduce((values, seller) => {
                    return values.concat(seller.goals.map(goal => {
                      return [
                        goal.id, seller.SlpCode, seller.SlpName, goal.provider_description, goal.item_description, goal.canal_description, goal.indicator_type, parseFloat(goal.goal),
                      ];
                    }));
                  }, []);
                },
              }}
            />
          </GridItem>
          <GridItem xs={4} md={4} lg={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Autocomplete
              fullWidth
              disableClearable
              options={sellers.filter((seller) => !minSellerIds.includes(seller.id))}
              getOptionLabel={(option) => option.SlpName}
              renderInput={(params) => (
                <TextField {...params} label="Vendedor" margin="normal" required />
              )}
              onChange={(e, seller) => setMinSeller(seller)}
            />
            <Button
              className={props.themeContext.buttonColorSuccess}
              onClick={() => addSellerGoals(1 /* Minorista */)}
              size="sm"
              style={{ marginLeft: 10 }}
            >
              Agregar vendedor
            </Button>
          </GridItem>

          <GoalTable
            removeSeller={removeSeller}
            canalId={1}
            providerGroups={providerGroups}
            categories={categories}
            sellerGoals={sellerGoals}
            setSellerGoals={setSellerGoals}
            classes={classes}
            showNotify={showNotify}
          />

          {/* Mayorista */}
          <GridItem xs={4} md={4} lg={4}>
            <h4>
              <b>Mayorista</b>
            </h4>
          </GridItem>
          <GridItem xs={12} md={12} lg={12}>
            <ImportExcel
              fileInputId="importar-mayorista"
              setDataImport={setDataImport}
              btnColor="success"
              btnLabel="Importar"
              validDuplicate="Codigo"
              downTemplate={{
                fileNameDown: 'metasMayorista',
                fields: [
                  'Codigo',
                  'SlpCode',
                  'Vendedor',
                  'Proveedor',
                  'Categoria',
                  'Canal',
                  'TipoMeta',
                  'Meta'
                ],
                data: function () {
                  return sellerGoals
                    .filter((seller) => seller.mayorista === 'Y')
                    .reduce((values, seller) => {
                      return values.concat(
                        seller.goals.map((goal) => {
                          return [
                            goal.id,
                            seller.SlpCode,
                            seller.SlpName,
                            goal.provider_description,
                            goal.item_description,
                            goal.canal_description,
                            goal.indicator_type,
                            parseFloat(goal.goal)
                          ];
                        })
                      );
                    }, []);
                }
              }}
            />
          </GridItem>
          <GridItem xs={4} md={4} lg={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Autocomplete
              fullWidth
              disableClearable
              options={sellers.filter((seller) => !maySellerIds.includes(seller.id))}
              getOptionLabel={(option) => option.SlpName}
              renderInput={(params) => (
                <TextField {...params} label="Vendedor" margin="normal" required />
              )}
              onChange={(e, seller) => setMaySeller(seller)}
            />
            <Button
              className={props.themeContext.buttonColorSuccess}
              onClick={() => addSellerGoals(2 /* Mayorista */)}
              size="sm"
              style={{ marginLeft: 10 }}
            >
              Agregar vendedor
            </Button>
          </GridItem>

          <GoalTable
            removeSeller={removeSeller}
            canalId={2}
            providerGroups={providerGroups}
            categories={categories}
            sellerGoals={sellerGoals}
            setSellerGoals={setSellerGoals}
            classes={classes}
            showNotify={showNotify}
          />
        </GridContainer>
      </CardBody>
    </Card>
  );
});

/**
 * Tabla de metas por canal
 */
const GoalTable = WithApp(function (props){
  const {
    canalId, providerGroups,categories,
    sellerGoals, setSellerGoals,
    classes, removeSeller,
    showNotify,
  } = props;

  const [updated, setUpdated] = useState(false);

  function handleGoalChange(e, goal){
    let sellerIndex = sellerGoals.findIndex(seller => seller.id === goal.base_seller_id);
    let goalIndex = sellerGoals[sellerIndex].goals.findIndex(fGoal => fGoal.id === goal.id);

    let newSellerGoals = [...sellerGoals];
    newSellerGoals[sellerIndex].updated = true;
    newSellerGoals[sellerIndex].goals[goalIndex].updated = true;
    newSellerGoals[sellerIndex].goals[goalIndex].goal = e.target.value;
    setSellerGoals(newSellerGoals);
    setUpdated(true);
  }

  async function saveGoals(){

    if(!updated){
      return;
    }

    let updatedSellers = sellerGoals.filter(seller => seller.updated === true);

    if(updatedSellers.length === 0){
      return;
    }

    let updatedGoals = updatedSellers.reduce((goals, seller) => {
      return goals.concat(seller.goals.filter(goal => goal.updated === true));
    }, []);

    if(updatedGoals.length === 0){
      return;
    }

    let incentiveId = updatedGoals[0].com_incentive_id;

    updatedGoals = updatedGoals.map(goal => {
      return {
        id: goal.id,
        goal: goal.goal,
      }
    });

    let response = await wsUpdate(`com/incentive/${incentiveId}/goal`, {
      goals: updatedGoals,
    });

    if(response.success){
      showNotify(response.message);
      setUpdated(false);
    }else{
      showNotify(response.message, 'error');
    }
  }

  return (
    <>
      <GridItem xs={12} md={12} lg={12}>
        <div className={classes.divTable}>
          <Table size="small" aria-label="Tabla de metas">
            <TableHead>
              <TableRow className={classes.tr}>
                <TableCell rowSpan={3} colSpan={2} align="center" style={{minWidth: '300px'}} className={classes.headerBorder}>
                  Vendedor
                </TableCell>

                {providerGroups.map((provider, index) => {
                  return <TableCell colSpan={provider.categories_count * 2} align="center" key={index} className={classes.headerBorder}>
                    {provider.provider_group_description ?? 'Focalizado'}
                  </TableCell>;
                })}

              </TableRow>
              <TableRow className={classes.tr}>

                {categories.map((category, index) => {
                  return <TableCell colSpan={2} align="center" style={{minWidth: '270px'}} key={index} className={classes.headerBorder}>
                    {category.item_code + ' ' + category.item_description}
                  </TableCell>;
                })}

              </TableRow>
              <TableRow className={classes.tr}>

                {categories.map((category, index) => {
                  let rewards = category.rewards.filter(reward => reward.base_canal_id == canalId);
                  let volumeReward = rewards.find(reward => reward.indicator_type === 'V');
                  let coverageReward = rewards.find(reward => reward.indicator_type === 'C');

                  return <Fragment key={index}>
                    <TableCell className={classes.headerBorder}>Volumen (S./{parseFloat(volumeReward.reward)})</TableCell>
                    <TableCell className={classes.headerBorder}>Cobertura (S./{parseFloat(coverageReward.reward)})</TableCell>
                  </Fragment>
                })}

              </TableRow>
              
            </TableHead>

            <TableBody>

                {sellerGoals.filter(seller => {
                  if(canalId === 1){
                    return seller.minorista === 'Y';
                  }else{
                    return seller.mayorista === 'Y';
                  }
                }).length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2 + categories.length * 2}>
                      <h4 style={{ marginLeft: '20px' }}>No hay vendedores asignados</h4>
                    </TableCell>
                  </TableRow>
                )
                :
                sellerGoals.filter(seller => {
                  if(canalId === 1){
                    return seller.minorista === 'Y';
                  }else{
                    return seller.mayorista === 'Y';
                  }
                }).map((seller, index) => {
                  return <TableRow key={index}>
                    <TableCell>({seller.SlpCode}) {seller.SlpName}</TableCell>
                    <TableCell style={{padding: 0}}>
                      <ButtonDelete
                        callback={() => removeSeller(seller.id, canalId)}
                        style={{ height: '0px' }}
                      />
                      
                      {/* <Button justIcon round onClick={() => removeSeller(seller.id, canalId)}><Delete/></Button> */}
                    </TableCell>

                    {categories.map((category, index) => {
                      let rewards = category.rewards.filter(reward => reward.base_canal_id == canalId);
                      let volumeReward = rewards.find(reward => reward.indicator_type === 'V');
                      let coverageReward = rewards.find(reward => reward.indicator_type === 'C');

                      let volumeGoal = seller.goals.find(goal => goal.com_incentive_reward_id == volumeReward.id);
                      let coverageGoal = seller.goals.find(goal => goal.com_incentive_reward_id == coverageReward.id);

                      return <Fragment key={index}>

                        <TableCell>
                          <InputField
                            type="number"
                            value={parseFloat(volumeGoal?.goal ?? 0)}
                            onChange={(e) => handleGoalChange(e, volumeGoal)}
                            inputProps={{ min: 0, step: 0.01 }}
                          />
                        </TableCell>
                        <TableCell>
                          <InputField
                            type="number"
                            value={parseFloat(coverageGoal?.goal ?? 0)}
                            onChange={(e) => handleGoalChange(e, coverageGoal)}
                            inputProps={{ min: 0, step: 0.01 }}
                          />
                        </TableCell>
                      </Fragment>;

                    })}

                  </TableRow>;
                })}

            </TableBody>

          </Table>
        </div>
      </GridItem>

      <GridItem xs={12} md={12} lg={12}>
        <Button color={props.themeContext.buttonColorSuccess} onClick={() => saveGoals()} disabled={!updated} style={{ float: 'right' }}>
          Guardar
        </Button>
      </GridItem>
    </>
  );
})
